import { createFileRoute } from "@tanstack/react-router";
import { DepositFormPage } from "../../pages/deposit";

export const Route = createFileRoute("/incentive/$objectId")({
  component: RouteComponent,
});

function RouteComponent() {
  return <DepositFormPage />;
}
